import { ValueOf } from '../../utils';

export const PointOfSale = {
  AU: 'AU',
  AT: 'AT',
  BE: 'BE',
  CN: 'CN',
  DK: 'DK',
  FI: 'FI',
  FR: 'FR',
  DE: 'DE',
  HK: 'HK',
  IS: 'IS',
  IE: 'IE',
  IT: 'IT',
  JP: 'JP',
  LT: 'LT',
  NL: 'NL',
  NO: 'NO',
  PL: 'PL',
  RU: 'RU',
  SG: 'SG',
  ES: 'ES',
  SE: 'SE',
  CH: 'CH',
  TH: 'TH',
  GB: 'GB',
  US: 'US',
  LU: 'LU',
  CA: 'CA',
  KR: 'KR',
} as const;

export type PointOfSale = ValueOf<typeof PointOfSale>;
